import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreatePriceCashSalesForm } from "./CreatePriceCashSalesForm";
import { RiskCashSale } from "@/lib/api/risk/cashSales/general";
import { type MarketZone } from "@/lib/api/generalContract";

interface PriceManualCashSalesFormDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    initialData?: RiskCashSale | null;
    marketZones?: MarketZone[];
}

export function CreatePriceCashSalesFormDialog({ isOpen, onClose, onSuccess, initialData, marketZones }: PriceManualCashSalesFormDialogProps) {
    const handleSuccess = () => {
        onSuccess();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="sm:max-w-[90vw] md:max-w-[80vw] lg:max-w-[80vw] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{initialData ? 'Price Manual Cash Sale (Pre-populated)' : 'Price Manual Cash Sale'}</DialogTitle>
                    <DialogDescription>
                    </DialogDescription>
                </DialogHeader>

                <CreatePriceCashSalesForm
                    onSuccess={handleSuccess}
                    onCancel={onClose}
                    showCancelButton={true}
                    initialData={initialData}
                    marketZones={marketZones}
                />
            </DialogContent>
        </Dialog>
    );
}
